import { ButtonProps } from "@chakra-ui/react";
import PrimaryButton from "components/PrimaryButton";
import { mobileStyleBreakpoint } from "util/styleHelpers";

const buttonWidth = mobileStyleBreakpoint("100%", "unset");

const OpenRequestOrderFormButton = ({
  onClick = () => {
    return;
  },
  variant = "primary",
  as,
  ...rest
}: ButtonProps & { to?: string; variant?: string }) => (
  <PrimaryButton
    as={as}
    onClick={onClick}
    w={buttonWidth}
    variant={variant}
    {...rest}
  >
    Request Order
  </PrimaryButton>
);

export default OpenRequestOrderFormButton;
